import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppAuthState } from "./use-app-auth-state";

export function useRedirectIfNotAdmin(path = "/") {
  const { isUserAdmin, isAdminLoading, isLoggedIn, isAuthLoading } =
    useAppAuthState();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isUserAdmin && !isAdminLoading) {
      navigate(path);
    }
  }, [isUserAdmin, isAdminLoading, isLoggedIn, isAuthLoading, navigate, path]);
}
